($ => {

	$( document ).ready( () => {
		const urlHash = window.location.hash;
		const $gridItem = $(`.modalGrid-gridItem-modal${urlHash}`);

		if( urlHash && $gridItem.size() ) {
			const gridId = $gridItem.data('grid-id');
			const gridItemId = $gridItem.data('grid-item-id');

			displayGridItem( gridId, gridItemId );
		}
	});

	const displayGridItem = ( gridId, gridItemId ) => {
		$('body').addClass('modalActive');

		$('.modalGrid-gridItem-modal')
			.removeClass('active')
			.attr( 'aria-hidden', 'true' )
			.filter(`[data-grid-id="${gridId}"][data-grid-item-id="${gridItemId}"]`)
			.addClass('active')
			.attr( 'aria-hidden', 'false' )
			.find( '.modalGrid-gridItem-modal-name' )
			.attr( 'tabindex', '0' );

		setTimeout( () => {
			$('.modalGrid-gridItem-modal.active .modalGrid-gridItem-modal-name').focus()
		}, 100);

		$( '.tabbedContent-tabPanels' ).attr( 'tabindex', '-1' );

		window.location.hash = `#${gridItemId}`;
	};

	const closeModal = () => {
		$('body').removeClass('modalActive');

		$('.modalGrid-gridItem-modal')
			.removeClass('active')
			.attr( 'aria-hidden', 'true' )
			.find( '.modalGrid-gridItem-modal-name' )
			.attr( 'tabindex', '' );

		window.location.hash = '_';
	};
	
	$('.modalGrid-gridItem-link.lightbox').click( event => {
		const gridId = $( event.currentTarget ).data('grid-id');
		const gridItemId = $( event.currentTarget ).data('grid-item-id');

		displayGridItem( gridId, gridItemId );
	});

	$('.modalGrid-gridItem-modal-closeButton').click( closeModal );
	$('.modalGrid-gridItem-modal-closeButton').keypress( ({ keyCode }) => keyCode == 13 ? closeModal() : null );

	// Arrows

	const advanceIndex = ( gridId, numSlidesToAdvance ) => {
		const $grid = $(`.modalGrid-gridItem-modal[data-grid-id=${gridId}]`);
		const numGridItems = $grid.size();
		const $currentGridItem = $grid.filter('.active');
		const currentIndex = $currentGridItem.data('modal-index');

		const index = ( currentIndex + numSlidesToAdvance + numGridItems ) % numGridItems;
		
		const $gridItemToDisplay = $grid.filter(`[data-modal-index="${index}"]`);
		const gridItemId = $gridItemToDisplay.data('grid-item-id');

		$('body').addClass('modalTransitioning');

		displayGridItem( gridId, gridItemId );

		setTimeout( () => $('body').removeClass('modalTransitioning'), 500 );
	};

	const prevArrowClick = event => {
		const gridId = $( event.currentTarget ).data('grid-id');

		advanceIndex( gridId, -1 );
	};

	const nextArrowClick = event => {
		const gridId = $( event.currentTarget ).data('grid-id');

		advanceIndex( gridId, 1 );
	};

	$('.modalGrid-gridItem-modal-prevArrow')
		.click( prevArrowClick )
		.keypress( event => keyCode == 13 ? prevArrowClick(event) : null );

	$('.modalGrid-gridItem-modal-nextArrow')
		.click( nextArrowClick )
		.keypress( event => keyCode == 13 ? nextArrowClick(event) : null );

	$( document ).keydown( ({ which }) => {
		const $activePerson = $('.modalGrid-gridItem-modal.active');

		if( $activePerson.size() ) {
			const gridId = $activePerson.data('grid-id');

			if( gridId ) {
				if( which === 37 ) advanceIndex( gridId, -1 );
				if( which === 39 ) advanceIndex( gridId, 1 );
			}
		}
	});

})(jQuery);



// WEBPACK FOOTER //
// ../benetech/js/components/modal-grid.js